/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IRevisionHistoryGetRevisionMessage extends IMessage {
	documentId: string;
	revisionId: string;
}

export default class RevisionHistoryGetRevisionMessage extends Message {
	public static readonly TYPE: string = '123';

	public static readonly READABLE_TYPE_NAME: string = 'getRevision';

	public static readonly DESCRIPTOR_NAME: string = 'RevisionHistoryGetRevisionMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			documentId: {
				type: 'string',
				id: 1
			},
			revisionId: {
				type: 'string',
				id: 2
			}
		}
	};

	public constructor( public readonly documentId: string, public readonly revisionId: string ) {
		super();
	}

	public toJSON(): IRevisionHistoryGetRevisionMessage {
		return {
			documentId: this.documentId,
			revisionId: this.revisionId
		};
	}

	public static fromJSON( object: IRevisionHistoryGetRevisionMessage ): RevisionHistoryGetRevisionMessage {
		return new RevisionHistoryGetRevisionMessage( object.documentId, object.revisionId );
	}
}
